// extracted by mini-css-extract-plugin
module.exports = {"root":"h2RKI","line":"_2UizT"};